/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-02T19:10:02.086
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentRepairWorkOrderAssignEditInit,
	getRentRepairWorkOrderAssignView
} from '@api/rentmanage/RentRepairWorkOrderAssign';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentRepairWorkOrderAssignEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderAssignEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairWorkOrderAssignView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderAssignView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
